<ng-container *transloco="let t; prefix: i18nScope">
  <div>
    <div class="font-bold">{{ t('DISPLAYED_COLS') }}</div>
    <div class="!max-h-[15rem] w-[15rem] overflow-auto my-[.5rem] pb-[.5rem]">
      @for (column of formArray.controls; track column) {
        <ng-container [formGroup]="column">
          <mat-checkbox class="!block" [formControl]="column.controls.display">
            {{ column.controls.label.value | resolveTranslateAbleText }}
          </mat-checkbox>
        </ng-container>
      }
    </div>
  </div>

  <div class="flex justify-end">
    <button mat-flat-button type="button" (click)="save()">
      {{ t('SAVE') }}
    </button>
  </div>
</ng-container>
